import * as React from "react";

function IndependentDataCheck({
	seriesAPIData,
	theFocusSeries,
	theFocusRegion
}) {
	//remove dupliates

	//create useEffect to set Env
	React.useEffect(() => {
		console.log("independent data check triggered");
		console.log(seriesAPIData, theFocusSeries, theFocusRegion);
		// console.log("theFocusSeries", theFocusSeries);
		const toyotaAPIName = buildSeriesAPIData(seriesAPIData, theFocusSeries);
		// console.log("toyotaAPIName: " + toyotaAPIName);

		dragElement(document.getElementById("feedsOfferHolder"));
	}, [theFocusRegion, theFocusSeries]);

	async function getOATData(regioncode, seriesname) {
		console.log("----resp[0].offerBundle.offers[0].optionTypeName");
		if (regioncode && seriesname) {
			var regionNumber = 0;
			//ne, cn, ww, cat, sc, sd, phx

			var apiKeys = [
				"V7qlHK7ML3iZOrt4SZ0o6yOoU62uCsz3h4Bmesta",
				"PFMRk6qir1HGZmBxgoLeUYwZ3dXSQgxyJ5o2vnqH",
				"74aQz0pUyohg3E2w9gCVn2a1q0tYs8Gbhi89Sr8X",
				"At6mfauZSy6cziSaPTiAp1QkVaovFxPQ5rpDP0pk",
				"93A4MR6OUgVGo8XwkSTwRAnxBZxbzGjURBAkO4gt",
				"M8siCfO1gJ8YYRepkMqT4TVawfsbZiFM0t0Z8x1P",
				"J4FdBGm4Hq8ld1P3E9Ayf5lxRM5nUVhm4k9ru8HB"
			];

			var clientKeys = [
				"5e6fc9312045400a940b659a3a7cc034",
				"2a7587ab3e994a6ab767dfde52018756",
				"e0c5ce3436c14da49fb20b4c580fee1c",
				"b7abb8a690d446e6886be6bc8be711ce",
				"c18062c8a66b44b78739fa17437da5cb",
				"260d06c88db645359ff25c11d5af25be",
				"861b01969cf34bcba013c82bcfd86aa3"
			];

			var regionZips = [
				"01062",
				"45231",
				"98148",
				"20855",
				"90015",
				"92029",
				"85009"
			];
			if (regioncode == "ne") {
				regionNumber = 0;
			} else if (regioncode == "cn") {
				regionNumber = 1;
			} else if (regioncode == "ww") {
				regionNumber = 2;
			} else if (regioncode == "cat") {
				regionNumber = 3;
			} else if (regioncode == "sc") {
				regionNumber = 4;
			} else if (regioncode == "sd") {
				regionNumber = 5;
			} else if (regioncode == "phx") {
				regionNumber = 6;
			}
			var apiKey = apiKeys[regionNumber];
			var clientKey = clientKeys[regionNumber];
			var regionZip = regionZips[regionNumber];
			var str_json = "";
			// console.log(apiKey);
			// `https://staging.ws.public.oatms.tms.aws.toyota.com/v2/marketing/offers/${regionZip}?clientId=${clientKey}&series=${seriesname}&brandId=1&lang=en`,
			//
			const response = await fetch(
				`https://www.ws.public.oatms.tms.aws.toyota.com/v2/marketing/offers/${regionZip}?clientId=${clientKey}&series=${seriesname}&brandId=1&lang=en`,
				{
					method: "GET",
					headers: {
						"x-api-key": apiKey,
						"Content-Type": "application/json"
					}
				}
			);
			const resp = await response.json();
			// console.log(resp);
			try {
				//loop through offers and find the first one that is not multiple vehicle or miscellaneous and display that one, if all are multiple vehicle or miscellaneous then display the first offer
				var offerIDToUse = 0;
				for (var i = 0; i < resp[0].offerBundle.offers.length; i++) {
					if (
						resp[0].offerBundle.offers[i].offerType &&
						resp[0].offerBundle.offers[i].offerType != "Multiple_Vehicle" &&
						resp[0].offerBundle.offers[i].offerType != "Miscellaneous"
					) {
						resp[0].offerBundle.offers[0] = resp[0].offerBundle.offers[i];
						offerIDToUse = i;
						break;
					}
				}
				//do not populate oat data in the overlay if it is multi
				if (
					resp[0].offerBundle.offers[offerIDToUse].offerType &&
					resp[0].offerBundle.offers[offerIDToUse].offerType !=
						"Multiple_Vehicle" &&
					resp[0].offerBundle.offers[offerIDToUse].offerType != "Miscellaneous"
				) {
					//we know we will have an oat offer to display
					document.getElementById("feedsOfferContent").innerHTML = "";
					buildMetaDivs("offerdescription", "oat", "", "OAT Offer Data");
					if (regioncode) {
						buildMetaDivs(
							"regioncode",
							"oat oatmeta",
							"Region Code:",
							regioncode
						);
					}

					if (resp[0].offerBundle.offers[offerIDToUse].seriesList.series.name) {
						buildMetaDivs(
							"seriesname",
							"oat oatmeta",
							"Series Name:",
							prepIDCSeriesName(
								resp[0].offerBundle.offers[0].seriesList.series.name
							)
						);
					}
					if (resp[0].offerBundle.offers[offerIDToUse].seriesList.series.id) {
						buildMetaDivs(
							"toyotaapiname",
							"oat oatmeta",
							"Toyota API Name:",
							resp[0].offerBundle.offers[offerIDToUse].seriesList.series.id
						);
					}
					if (resp[0].offerBundle.offers[offerIDToUse].seriesList.series.year) {
						buildMetaDivs(
							"modelyear",
							"oat oatmeta",
							"Model Year:",
							resp[0].offerBundle.offers[offerIDToUse].seriesList.series.year
						);
					}

					if (
						typeof resp[0].offerBundle.offers[offerIDToUse].apr !== "undefined"
					) {
						if (
							resp[0].offerBundle.offers[offerIDToUse].apr.tiers.tier[0].term[0]
								.extraCashAmount &&
							resp[0].offerBundle.offers[offerIDToUse].apr.tiers.tier[0].term[0]
								.extraCashAmount != 0
						) {
							if (resp[0].offerBundle.offers[offerIDToUse].offerType) {
								buildMetaDivs(
									"offertype",
									"oat oatmeta",
									"Offer Type:",
									"APRCash"
								);
							}
							//extra cash amount
							buildMetaDivs(
								"aprcashbackamount",
								"oat oatmeta",
								"Extra Cash Back:",
								resp[0].offerBundle.offers[offerIDToUse].apr.tiers.tier[0]
									.term[0].extraCashAmount
							);
							buildMetaDivs(
								"aprcashbacklabel",
								"oat oatmeta",
								"APR Cash Back Label Extra:",
								resp[0].offerBundle.offers[offerIDToUse].apr.tiers.tier[0]
									.term[0].extraCashLabel
							);
						} else if (
							resp[0].offerBundle.offers[offerIDToUse].apr
								.subventionDollarAmount &&
							resp[0].offerBundle.offers[offerIDToUse].apr
								.subventionDollarAmount != 0
						) {
							if (resp[0].offerBundle.offers[offerIDToUse].offerType) {
								buildMetaDivs(
									"offertype",
									"oat oatmeta",
									"Offer Type:",
									"APRCash"
								);
							}
							//update #offertype .metabody to aprcash

							//subvention cash amount
							buildMetaDivs(
								"aprcashbackamount",
								"oat oatmeta",
								"Subvention Cash Back:",
								resp[0].offerBundle.offers[offerIDToUse].apr
									.subventionDollarAmount
							);
							buildMetaDivs(
								"aprcashbacklabel",
								"oat oatmeta",
								"APR Cash Back Label:",
								"TFS Finance Cash"
							);
						} else {
							if (resp[0].offerBundle.offers[offerIDToUse].offerType) {
								buildMetaDivs("offertype", "oat oatmeta", "Offer Type:", "APR");
							}
						}
						buildMetaDivs(
							"aprrate",
							"oat oatmeta",
							"APR Rate:",
							resp[0].offerBundle.offers[offerIDToUse].apr.tiers.tier[0].term[0]
								.rate
						);

						buildMetaDivs(
							"aprterm",
							"oat oatmeta",
							"APR Term:",
							resp[0].offerBundle.offers[offerIDToUse].apr.tiers.tier[0].term[0]
								.duration
						);
					}
				}

				if (
					typeof resp[0].offerBundle.offers[offerIDToUse].lease !== "undefined"
				) {
					buildMetaDivs(
						"seriestrim",
						"oat oatmeta",
						"Trim:",
						resp[0].offerBundle.offers[offerIDToUse].seriesList.series
							.includedModels.includedModel[0].name
					);
					if (resp[0].offerBundle.offers[offerIDToUse].offerType) {
						buildMetaDivs(
							"offertype",
							"oat oatmeta",
							"Offer Type:",
							resp[0].offerBundle.offers[offerIDToUse].offerType
						);
					}
					buildMetaDivs(
						"leasemonthly",
						"oat oatmeta",
						"Lease Monthly:",
						resp[0].offerBundle.offers[offerIDToUse].lease.tiers.tier[0].term[0]
							.monthlyPayment
					);

					buildMetaDivs(
						"leaseterm",
						"oat oatmeta",
						"Lease Term:",
						resp[0].offerBundle.offers[offerIDToUse].lease.tiers.tier[0].term[0]
							.duration
					);

					buildMetaDivs(
						"leasedas",
						"oat oatmeta",
						"Lease DAS:",
						resp[0].offerBundle.offers[offerIDToUse].lease.tiers.tier[0].term[0]
							.dueAtSigningAmount
					);
				}
				//cash offer
				if (
					typeof resp[0].offerBundle.offers[offerIDToUse].cash !== "undefined"
				) {
					if (resp[0].offerBundle.offers[offerIDToUse].offerType) {
						buildMetaDivs(
							"offertype",
							"oat oatmeta",
							"Offer Type:",
							resp[0].offerBundle.offers[offerIDToUse].offerType
						);
					}
					buildMetaDivs(
						"cashamount",
						"oat oatmeta",
						"Cash Back Amount:",
						resp[0].offerBundle.offers[offerIDToUse].cash.cashAmount
					);
					if (
						typeof resp[0].offerBundle.offers[offerIDToUse].optionTypeName !==
						"undefined"
					) {
						buildMetaDivs(
							"cashlabel",
							"oat oatmeta",
							"Cash Back Label:",
							resp[0].offerBundle.offers[offerIDToUse].optionTypeName
						);
					}
				}
				document.getElementById("feedsOfferContent").style.display = "block";
				// return data;
			} catch (e) {
				console.log(e);
			}
		}
	}
	function prepIDCSeriesName(seriesName) {
		seriesName = seriesName.replace("Toyota ", "");
		seriesName = seriesName.replace("RAV4 Prime", "RAV4 Plug-In Hybrid");
		return seriesName;
	}
	// setAllCampaigns(campaigns);
	// console.log(campaigns);
	function buildSeriesAPIData(seriesAPIData, theFocusSeries) {
		console.log("buildSeriesAPIData");
		var toyotaAPIName = "";
		document.getElementById("feedsOfferContent").innerHTML = "";
		seriesAPIData.map((series) => {
			// console.log(series.seriesname, theFocusSeries);
			if (series.seriesname == theFocusSeries) {
				// console.log("found");
				toyotaAPIName = series.ToyotaAPIName;
				buildMetaDivs("offerdescription", "seriesapi", "", "Series API Data");

				buildMetaDivs(
					"seriesname",
					"seriesapi seriesapimeta",
					"Series Name:",
					series.seriesname
				);
				buildMetaDivs(
					"modelyear",
					"seriesapi seriesapimeta",
					"Model Year:",
					series.modelyear
				);
				buildMetaDivs(
					"seriescode",
					"seriesapi seriesapimeta",
					"Series Code:",
					series.seriescode
				);

				buildMetaDivs(
					"toyotaapiname",
					"seriesapi seriesapimeta",
					"Toyota API Name:",
					series.ToyotaAPIName
				);

				buildMetaDivs(
					"offertype",
					"seriesapi seriesapimeta",
					"Offer Type:",
					"Custom"
				);
				buildMetaDivs(
					"customtext",
					"seriesapi seriesapimeta",
					"Custom Text:",
					"See Limited Time Deals!"
				);
				getOATData(theFocusRegion, toyotaAPIName);
			}
		});
	}

	function buildMetaDivs(id, classname, labeltext, bodytext) {
		//if there is a body then build the div
		if (bodytext) {
			let holder = document.createElement("div");
			holder.id = id;
			holder.className = classname;
			document.getElementById("feedsOfferContent").appendChild(holder);
			let label = "";
			if (labeltext) {
				label = document.createElement("span");
				label.innerHTML = labeltext;
				label.className = "metalabel";
				holder.appendChild(label);
			}

			let body = document.createElement("span");
			body.innerHTML = bodytext;
			body.className = "metabody";
			holder.appendChild(body);
		}
	}
	// Make the DIV element draggable:
	function dragElement(elmnt) {
		var pos1 = 0,
			pos2 = 0,
			pos3 = 0,
			pos4 = 0;
		if (document.getElementById(elmnt.id + "header")) {
			// if present, the header is where you move the DIV from:
			document.getElementById(elmnt.id + "header").onmousedown = dragMouseDown;
		} else {
			// otherwise, move the DIV from anywhere inside the DIV:
			elmnt.onmousedown = dragMouseDown;
		}

		function dragMouseDown(e) {
			e = e || window.event;
			e.preventDefault();
			// get the mouse cursor position at startup:
			pos3 = e.clientX;
			pos4 = e.clientY;
			document.onmouseup = closeDragElement;
			// call a function whenever the cursor moves:
			document.onmousemove = elementDrag;
		}

		function elementDrag(e) {
			e = e || window.event;
			e.preventDefault();
			// calculate the new cursor position:
			pos1 = pos3 - e.clientX;
			pos2 = pos4 - e.clientY;
			pos3 = e.clientX;
			pos4 = e.clientY;
			// set the element's new position:
			elmnt.style.top = elmnt.offsetTop - pos2 + "px";
			elmnt.style.left = elmnt.offsetLeft - pos1 + "px";
		}

		function closeDragElement() {
			// stop moving when mouse button is released:
			document.onmouseup = null;
			document.onmousemove = null;
		}
	}
	// Function to keep feedsOfferHolder in view on scroll
	React.useEffect(() => {
		function handleScroll() {
			const feedsOfferHolder = document.getElementById("feedsOfferHolder");
			const rect = feedsOfferHolder.getBoundingClientRect();
			const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;
			if (!isVisible) {
				//move the div into view
				feedsOfferHolder.style.top = `${window.scrollY + 10}px`;
			}
		}

		window.addEventListener("scroll", handleScroll);
		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, []);
	return (
		<div id="feedsOfferHolder">
			<div id="feedsHeader">Independent Data Check</div>
			<div id="feedsOfferContent"></div>
		</div>
	);
}
export default IndependentDataCheck;
